import { CSSProperties } from 'react';

// The brand-family hairline icon set, ported from Tradehaus (components/tx/ui.jsx). Every glyph is a single path
// on a 24px grid, drawn in currentColor with round caps. Prefer these over @mui/icons-material in new and restyled
// UI; size 16 inside controls, 18 in icon buttons, 22 in tiles.
/* eslint-disable max-len */
const PATHS = {
  calendar: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  flask: 'M9 3h6M10 3v6.5L4.6 18.8A1.5 1.5 0 0 0 5.9 21h12.2a1.5 1.5 0 0 0 1.3-2.2L14 9.5V3M7.2 15h9.6',
  saw: 'M20.4 12 L22.34 15.44 L19.89 14.87 L20.54 18.77 L18.43 17.4 L17.71 21.28 L16.2 19.27 L14.19 22.68 L13.46 20.27 L10.41 22.78 L10.54 20.27 L6.82 21.59 L7.8 19.27 L3.85 19.24 L5.57 17.4 L1.87 16.01 L4.11 14.87 L1.1 12.3 L3.6 12 L1.66 8.56 L4.11 9.13 L3.46 5.23 L5.57 6.6 L6.29 2.72 L7.8 4.73 L9.81 1.32 L10.54 3.73 L13.59 1.22 L13.46 3.73 L17.18 2.41 L16.2 4.73 L20.15 4.76 L18.43 6.6 L22.13 7.99 L19.89 9.13 L22.9 11.7Z M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z',
  planks: 'M3 4.5h12v3H3zM9 10.5h12v3H9zM3 16.5h13v3H3z',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.3-4.3',
  filter: 'M3 5h18M6 12h12M10 19h4',
  up: 'M12 19V5m-6 6 6-6 6 6',
  down: 'M12 5v14m6-6-6 6-6-6',
  map: 'M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Zm0 0v14m6-12v14',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  menu: 'M4 7h16M4 12h16M4 17h16',
  bell: 'M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9Zm4.3 13a2 2 0 0 0 3.4 0',
  plus: 'M12 5v14M5 12h14',
  x: 'M18 6 6 18M6 6l12 12',
  mic: 'M12 15a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Zm6-3a6 6 0 0 1-12 0m6 6v3',
  stop: 'M7 7h10v10H7z',
  note: 'M5 4h14v12l-4 4H5V4Zm10 16v-4h4M8 9h8M8 13h5',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-8 9a8 8 0 0 1 16 0',
  star: 'm12 3 2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.8 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8L12 3Z',
  navigate: 'M3.5 10.5 20.5 3.5l-7 17-2.2-7.6-7.8-2.4Z',
  route: 'M12 21v-6M12 15c0-2-1.3-3.4-2.8-4.9L5 6M5 11V6h5M12 15c0-2 1.3-3.4 2.8-4.9L19 6M14 6h5v5',
  unfold: 'M8 9l4-4 4 4M8 15l4 4 4-4',
  pin: 'M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Zm0-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  check: 'm5 12 5 5L20 7',
  chev: 'm6 9 6 6 6-6',
  'chev-right': 'm9 6 6 6-6 6',
  trash: 'M4 7h16M10 11v6m4-6v6M6 7l1 13h10l1-13M9 7V4h6v3',
  copy: 'M9 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zM16 9V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Zm7 12 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z',
  hello: 'M8.27 14.51L10.42 5.88A1.5 1.5 0 0 1 13.33 6.6L12.24 10.97M12.24 10.97L13.69 5.15A1.5 1.5 0 0 1 16.6 5.87L15.15 11.69M15.15 11.69L16.24 7.33A1.5 1.5 0 0 1 19.15 8.05L17.82 13.39M17.82 13.39L18.43 10.96A1.5 1.5 0 0 1 21.34 11.69L20.25 16.06A7 7 0 0 1 11.76 21.15L10.21 20.77A6 6 0 0 1 6.33 17.74L3.8 12.99A1.6 1.6 0 0 1 6.64 11.53L8.27 14.51M3.6 7.6A6 6 0 0 1 6.2 3.6M2 5.8A8 8 0 0 1 3.9 2.6',
  layers: 'm12 3 9 5-9 5-9-5 9-5Zm-9 9 9 5 9-5m-18 4 9 5 9-5',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  'eye-off': 'M3 3l18 18M10.6 5.1A10.4 10.4 0 0 1 12 5c6.4 0 10 7 10 7a17 17 0 0 1-3.2 4.1M6.6 6.6C3.8 8.4 2 12 2 12s3.6 7 10 7c1.9 0 3.5-.6 4.9-1.4M9.9 9.9a3 3 0 0 0 4.2 4.2',
  lock: 'M6 11h12v9H6zM8 11V8a4 4 0 0 1 8 0v3',
  unlock: 'M6 11h12v9H6zM8 11V8a4 4 0 0 1 7.7-1.5',
  locate: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0-6v3m0 14v3M2 12h3m14 0h3',
  download: 'M12 4v11m-5-5 5 5 5-5M5 20h14',
  tag: 'M3 12V4h8l10 10-8 8L3 12Zm5-4h.01',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v5l3 2',
  ext: 'M14 4h6v6m0-6L10 14M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.3l2-1.5-2-3.4-2.3.9a7.6 7.6 0 0 0-2.2-1.3L14.4 3h-4l-.4 2.4a7.6 7.6 0 0 0-2.2 1.3l-2.3-.9-2 3.4 2 1.5A7.4 7.4 0 0 0 5 12c0 .4 0 .9.1 1.3l-2 1.5 2 3.4 2.3-.9c.7.5 1.4 1 2.2 1.3l.4 2.4h4l.4-2.4c.8-.3 1.5-.8 2.2-1.3l2.3.9 2-3.4-2-1.5c.1-.4.1-.9.1-1.3Z',
  play: 'M8 5v14l11-7L8 5Z',
  pause: 'M7 5h3v14H7zM14 5h3v14h-3z',
  phone: 'M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.6a2 2 0 0 1-.5 2.1L8.1 9.7a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.8.3 1.7.6 2.6.7a2 2 0 0 1 1.9 2.2Z',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-18c3 3 3 15 0 18M3 12h18',
  'arrow-out': 'M7 17 17 7M8 7h9v9',
  'arrow-up': 'M12 19V5m-6 6 6-6 6 6',
  mix: 'M3 7A2 2 0 0 1 5 5L11 5A2 2 0 0 1 13 7A2 2 0 0 1 11 9L5 9A2 2 0 0 1 3 7ZM3 17A2 2 0 0 1 5 15L17 15A2 2 0 0 1 19 17A2 2 0 0 1 17 19L5 19A2 2 0 0 1 3 17Z',
  topo: 'M4 10.5C4 6.5 6.8 3.6 10.3 4.2C12.4 4.6 13.2 3 15.8 3.4C19 3.9 21 6.6 20.2 9.4C19.7 11.2 18.2 11.4 18.6 13.4C19.1 16 17 18.9 13.6 18.8C11.6 18.7 10.8 17.6 8.8 18.3C5.8 19.3 3.2 16.8 3.6 14C3.8 12.6 4 11.8 4 10.5ZM7 10.8C6.9 8.4 8.7 6.9 10.8 7.4C12.2 7.7 12.8 6.6 14.6 6.9C16.6 7.3 17.3 9.2 16.4 10.6C15.8 11.5 16 12.4 15.6 13.6C15 15.3 12.8 15.6 11.6 14.7C10.8 14.1 10 14.6 8.9 14.3C7.6 13.9 7.1 12.4 7 10.8ZM10.2 10.2C10.6 9.3 11.8 9.3 12.1 10.1C12.4 10.9 11.8 11.7 11 11.6C10.3 11.5 9.9 10.9 10.2 10.2ZM13.6 9.6C14.2 9.2 15 9.6 14.9 10.3C14.8 10.9 14.1 11.1 13.6 10.8C13.2 10.5 13.2 9.9 13.6 9.6Z',
  territory: 'M12 12h.01M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  refresh: 'M21 12a9 9 0 0 1-15.5 6.2L3 16m0 0v5m0-5h5M3 12a9 9 0 0 1 15.5-6.2L21 8m0 0V3m0 5h-5',
  instagram: 'M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm5 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm5.5-2.5h.01',
  select: 'M4 4h4M10 4h4M16 4h4v4M20 10v4M20 16v4h-4M14 20h-4M8 20H4v-4M4 14v-4M4 8V4',
  camera: 'M4 8h3l2-3h6l2 3h3v11H4V8Zm8 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
  landscape: 'M3.5 5.5h17v13h-17v-13Zm0 10.5 5-5.5 4 4.5 2.5-2.5 5.5 5M15.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  video: 'M3 7h12v10H3V7Zm12 3.5 6-3.5v10l-6-3.5',
  car: 'M5 11l1.6-4.3A2 2 0 0 1 8.5 5.4h7a2 2 0 0 1 1.9 1.3L19 11M3.5 11h17a.5.5 0 0 1 .5.5V17H3v-5.5a.5.5 0 0 1 .5-.5ZM6 17v2M18 17v2M7 14h1M16 14h1',
  wave: 'M4 10v4M8 7v10M12 4v16M16 7v10M20 10v4',
  boards: 'M4 10h16v10H4V10Zm2-3h12M8 4h8',
  pen: 'M4 20h4L19 9l-4-4L4 16v4Zm11-15 4 4',
  columns: 'M5 4h4v16H5zM10 4h4v10h-4zM15 4h4v6h-4z',
  sidebar: 'M6 4h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Zm4 0v16M6 8h1M6 11h1',
  bolt: 'M13 2 4 14h7l-1 8 9-12h-7l1-8z',
  sample: 'M5 8.5 12 4.5l7 4v7l-7 4-7-4zM5 8.5 12 12.5l7-4M12 12.5v7',
  floorplan: 'M5 4.5h14A1.5 1.5 0 0 1 20.5 6v12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 18V6A1.5 1.5 0 0 1 5 4.5zM10 4.5v8h10.5M10 16v3.5',
  quotedoc: 'M6.5 3.5h8l3 3v14h-11zM9.5 11h5M9.5 14.5h5M9.5 7.5h2',
  swatch: 'M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2ZM16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7M7 17h.01M11 8l2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8',
  grid: 'M5 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM15 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM5 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zM15 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z',
  chart: 'M4 20V11h4v9zM10 20V4h4v16zM16 20v-6h4v6z',
  perform: 'M3 18l5.5-6 4 3.5L21 6M16 6h5v5',
  funnel: 'M3.5 5h17l-6.5 7.5V19l-4-2v-4.5L3.5 5Z',
  dash: 'M4.5 4h5.5a.5.5 0 0 1 .5.5V10a.5.5 0 0 1-.5.5H4.5A.5.5 0 0 1 4 10V4.5a.5.5 0 0 1 .5-.5ZM14 4h5.5a.5.5 0 0 1 .5.5V10a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5V4.5A.5.5 0 0 1 14 4ZM4.5 13.5h5.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5ZM14 13.5h5.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5Z',
  catalog: 'M4 5h7v14H4zM13 5h7v6h-7zM13 13h7v6h-7z',
  dollar: 'M12 3v18M16.5 7.6C15.7 6.3 14.1 5.5 12 5.5c-2.6 0-4.2 1.2-4.2 3 0 4.4 8.9 1.9 8.9 6.5 0 1.8-1.7 3.5-4.7 3.5-2.3 0-4-.9-4.8-2.4',
  award: 'M12 2a6 6 0 1 0 0 12a6 6 0 1 0 0-12ZM8.5 12.9 7 22l5-3 5 3-1.5-9.1',
  book: 'M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2V4ZM22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7V4Z',
  dots4: 'M10 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM20 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM10 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM20 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  contact: 'M3.5 6.5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2zM9 12.5a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6ZM5.5 16.5a3.6 3.6 0 0 1 7 0M14.5 9.5h3.5M14.5 13h3.5',
  crew: 'M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6.5 20a5.5 5.5 0 0 1 11 0M5 12.4a2.2 2.2 0 1 1 0-4.4M19 12.4a2.2 2.2 0 1 0 0-4.4M1.5 19a4 4 0 0 1 3.2-3.9M22.5 19a4 4 0 0 0-3.2-3.9',
  team: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2.5 20a6.5 6.5 0 0 1 13 0M16.5 4.3a3.5 3.5 0 0 1 0 6.4M18 14a6.5 6.5 0 0 1 3.5 6',
  mail: 'M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm18 2.5-10 6.5L2 7.5',
  connect: 'M9 6a6 6 0 1 0 0 12a6 6 0 1 0 0-12ZM15 6a6 6 0 1 0 0 12a6 6 0 1 0 0-12Z',
  send: 'M21 3 10 14M21 3l-6.5 18-4.5-7-7-4.5L21 3Z',
  bulb: 'M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.7.5 1.1 1.3 1.1 2.1V16h5v-.1c0-.8.4-1.6 1.1-2.1A6 6 0 0 0 12 3Z',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-2.6-11.6a2.6 2.6 0 1 1 3.6 2.4c-.6.3-1 .8-1 1.5v.5M12 17h.01',
  clip: 'M21.4 11.1l-9.2 9.2a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5',
  alert: 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0ZM12 9v4M12 17h.01',
  keyboard: 'M3 7h18v10H3V7Zm3 3h.01M9 10h.01M12 10h.01M15 10h.01M18 10h.01M7 14h10',
  fit: 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5M9.5 12h5M12 9.5v5',
  expand: 'M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5',
  shrink: 'M9 4v5H4M20 9h-5V4M15 20v-5h5M4 15h5v5',
  home: 'M3 11.5 12 4l9 7.5M5.5 9.5V20h13V9.5M10 20v-5.5h4V20',
  pegman: 'M12 3.2a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8ZM6 10.5l6-1.6 6 1.6M12 8.9v5.7M12 14.6 8.6 21M12 14.6 15.4 21',
  thumbup: 'M7 11v9H4v-9h3Zm0 0 4-8a2 2 0 0 1 2 2v4h6a1 1 0 0 1 1 1.2l-1.5 7A2 2 0 0 1 16.5 20H7',
  thumbdown: 'M7 13V4H4v9h3Zm0 0 4 8a2 2 0 0 0 2-2v-4h6a1 1 0 0 0 1-1.2l-1.5-7A2 2 0 0 0 16.5 4H7',
  calc: 'M7 3.8v6.4M3.8 7h6.4M13.8 7h6.4M4.6 14.6l4.8 4.8m0-4.8-4.8 4.8M13.8 17h6.4M17 14.2h.01M17 19.8h.01',
  moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z',
  minus: 'M5 12h14',
  resize: 'M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M5 13h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z',
  today: 'M6 4h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM6 14h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zM15 14h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-13v2m0 14v2M3 12h2m14 0h2M5.6 5.6 7 7m10 10 1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4',
  cloud: 'M7 18h10a4 4 0 0 0 .4-8A6 6 0 0 0 6 10.5 3.8 3.8 0 0 0 7 18Z',
  partly: 'M9 3v1.5M3.6 5.6l1 1M2 11h1.5M14.4 5.6l-1 1M5.8 12.6A4 4 0 1 1 12.9 9M9 20h8.5a3.5 3.5 0 0 0 .3-7 5 5 0 0 0-9.4 1.4A2.8 2.8 0 0 0 9 20Z',
  rain: 'M7 15h10a4 4 0 0 0 .4-8A6 6 0 0 0 6 7.5 3.8 3.8 0 0 0 7 15Zm1 3-1 2.5m5-2.5-1 2.5m5-2.5-1 2.5',
  snow: 'M7 14h10a4 4 0 0 0 .4-8A6 6 0 0 0 6 6.5 3.8 3.8 0 0 0 7 14Zm1 4v.01M12 18v.01M16 18v.01M10 21v.01M14 21v.01',
  storm: 'M7 14h10a4 4 0 0 0 .4-8A6 6 0 0 0 6 6.5 3.8 3.8 0 0 0 7 14Zm6 0-2 3.5h3l-2 3.5',
  fog: 'M4 9h16M3 13h18M5 17h14',
  more: 'M12 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 21a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
} as const;
/* eslint-enable max-len */

export type IconName = keyof typeof PATHS | 'donut';

// a few icons read better in a finer line than the default
const THIN: Partial<Record<IconName, number>> = { dash: 1.5 };

export interface IconProps {
  name: IconName;
  size?: number;
  stroke?: number;
  fill?: boolean;
  style?: CSSProperties;
  className?: string;
}

export const Icon = ({ name, size = 18, stroke = 2, fill = false, style, className }: IconProps) => {
  // the one two-tone icon: three quarters in the icon's colour, the last quarter in a light tint of it
  if (name === 'donut') {
    return (
      <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth={3.4}
        style={style}
        aria-hidden="true">
        <path d="M12.87 3.75A8.3 8.3 0 1 1 3.75 12.87" stroke="currentColor" />
        <path d="M3.75 11.13A8.3 8.3 0 0 1 11.13 3.75" stroke="currentColor" strokeOpacity={0.32} />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={stroke === 2 && THIN[name] ? THIN[name] : stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flex: 'none', ...style }}>
      <path d={PATHS[name]} />
    </svg>
  );
};
